// extracted by mini-css-extract-plugin
export default {"create_series":"CreateSeries_create_series__05la1","heading":"CreateSeries_heading__uA-ym"};